import { Spreadsheet, getRangeAddress } from '@syncfusion/ej2-spreadsheet';
import { Uploader } from '@syncfusion/ej2-inputs';
import { ExcelWorksheetCellModel, ExcelWorksheetModel, SetWorkbookDataModel } from '../../Models/Excel/SetWorkbookDataModel';
import { ExcelDataService } from '../../DataService/ExcelDataService';

import { Grid, Filter, Page, Sort, RecordClickEventArgs, Edit, Toolbar, NewRowPosition } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { closest, L10n } from '@syncfusion/ej2-base';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { Toastr } from '../../Helpers/Toastr';
import { DropDownList, ChangeEventArgs } from '@syncfusion/ej2-dropdowns';
import { ConfirmModal } from '../../Helpers/ConfirmModal';
import { LookupDataService } from '../../DataService/LookupDataService';
import { CommonTablesDataService } from '../../DataService/CommonTablesDataService';

export class DepartmentCrossReferencesManager {

    constructor(private containerElement: JQuery) { }

    private erpGrid : Grid;
    private crossReferencesGrid : Grid;
    

    public initialize() {
        var self = this;

        Grid.Inject(Edit, Toolbar, Filter, Page, Sort);

        self.initializeDepartmentsTable();
    }

    private initializeDepartmentsTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var departmentCrossReferencesContainer = self.containerElement.find('#department-cross-references-container');

        var erpContentWrapper : JQuery<HTMLElement> = self.containerElement.find('#erp-workbook-content-wrapper');
        var erpGridElement : JQuery<HTMLElement> = self.containerElement.find('#erp-grid');
        var erpContentElement : JQuery<HTMLElement> = erpGridElement;

        var uploadObject : Uploader;
        var uploadedDocumentId = '';

 
        var crossReferencesGridElement : JQuery<HTMLElement> = self.containerElement.find('#cross-references-grid');
        var crossReferencesContentElement : JQuery<HTMLElement> = crossReferencesGridElement;

        var updateFromErpButton = self.containerElement.find('#update-from-erp-button');
        updateFromErpButton.off('click').on('click', () => {
            new ConfirmModal().initialize('Update departments from ERP', 'Are you sure you want to update the departments from the ERP?</br>This action cannot be reverted.', () => {
                CommonTablesDataService.updateDepartmentsFromErp((success) => {
                    location.reload();
                })
            }, () => {
            }, 'Confirm', 'Cancel')
        })

        var fileUploadInput = self.containerElement.find('#erp-department-file-upload-input');
    
        L10n.load({
            "department-en-US": {
                "uploader": { 
                    "dropFilesHint" : "Drop a file with department(s) here"
                }
            }
        })

        //TODO: Allow upload of erp department file
        uploadObject = new Uploader({
            maxFileSize: 40000000,
            autoUpload: false,
            asyncSettings: {
                saveUrl: '/api/company/commontables/erp/uploaddepartmentxlsx',
                removeUrl: '/api/company/commontables/removefile'
            },
            multiple: false,
            allowedExtensions: '.xlsx',
            locale: 'department-en-US',
            created: () => {
                loadingContainer.addClass('d-none');
                departmentCrossReferencesContainer.removeClass('d-none');
            },
            beforeUpload: () => {
                //spreadsheetElement.addClass('d-none');
                //spreadsheet.destroy();
            },
            selected: () => {
                erpContentWrapper.css('height', 'calc(85dvh - 98px)');
            },
            success: (args: any) => {                    
                if (args.operation == 'upload') {
                    uploadedDocumentId = args.e.target.response;
                    //spreadsheet.open({ file: args.file.rawFile });
                }
            },
        });

        let erpData: DataManager = new DataManager({
            url: '/api/company/lookup/erp/department',
            adaptor: new WebApiAdaptor
        });

        self.erpGrid = new Grid(
        {
            height: '100%',
            dataSource: erpData,
            editSettings: { allowEditing: true, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
            columns: [
                { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
                { field: 'CreationDateTimeString', headerText: 'Creation date', autoFit: true, allowEditing: false, width: '150px', validationRules: { required: true }},
                { field: 'Department', headerText: 'Department', autoFit: true, validationRules: { required: false }},
                
            ],
            allowSorting: true,
            allowPaging: true,
            allowFiltering: false,
            allowSelection: false,
            pageSettings: { pageSize: 100 },
            // toolbar: ['Update', 'Cancel'],
            //actionComplete: actionComplete,
            created: () => {
                erpContentElement = erpContentElement.find('.e-content')

                loadingContainer.addClass('d-none');
                departmentCrossReferencesContainer.removeClass('d-none');

            }
        });

        self.erpGrid.appendTo('#erp-grid');

        
        var fileInput = fileUploadInput.get(0);
        // render initialized Uploader
        uploadObject.appendTo(fileInput);

        fileUploadInput.removeClass('d-none');


        let data: DataManager = new DataManager({
            url: '/api/company/lookup/crossreferences/department',
            adaptor: new WebApiAdaptor
        });

        self.crossReferencesGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                editSettings: { allowEditing: true, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
                columns: [
                    { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
                    { field: 'CreationDateTimeString', headerText: 'Creation date', autoFit: true, allowEditing: false, width: '150px', validationRules: { required: true }},
                    { field: 'DepartmentName', headerText: 'Department', autoFit: true, validationRules: { required: false }},
                    { field: 'ErpDepartmentName', headerText: 'ERP Department', autoFit: true, validationRules: { required: false }},
                    { field: 'ExtraActions', headerText: '', allowFiltering: false, allowEditing: false, autoFit: true, width: '75px', textAlign: 'Right', template: '${getDepartmentCrossReferencesExtraActions(data.Id)}' }
                ],
                allowSorting: true,
                allowPaging: true,
                allowFiltering: false,
                allowSelection: false,
                pageSettings: { pageSize: 100 },
                // toolbar: ['Update', 'Cancel'],
                //actionComplete: actionComplete,
                created: () => {
                    crossReferencesContentElement = crossReferencesContentElement.find('.e-content')

                    loadingContainer.addClass('d-none');
                    departmentCrossReferencesContainer.removeClass('d-none');

                },
                dataBound: () => {
                    self.containerElement.find('button[data-action="remove-department-xref"]').each((index, element) => {
                        var deleteButton = $(element);
                        deleteButton.off('click').on('click', () => {
                            var xrefId = deleteButton.data('entity-id');
                            new ConfirmModal().initialize('Remove Department Cross Reference', 'Are you sure you want to remove this cross reference?</br>This action cannot be reverted.', () => {
                                LookupDataService.removeDepartmentCrossReference(xrefId, (result) => {
                                    if(result == true) {
                                        var index = self.crossReferencesGrid.getRowIndexByPrimaryKey(xrefId);
                                        var row = self.crossReferencesGrid.getRowByIndex(index);
                                        $(row).remove();
                                    }
                                })
                            }, () => {
                            }, 'Confirm', 'Cancel')
                            
                        })
                    })
                }
            });

        self.crossReferencesGrid.appendTo('#cross-references-grid');

        // function actionComplete(args) {
        //     if ((args.requestType == 'save')) {
        //         args.promise.then((result) => {
        //             if(result.isSuccessStatusCode == false) {
        //                 Toastr.Error("Error when adding cross reference", args.reasonPhrase);
        //             }
        //         })
        //     }
        // }
    }
    

}